const IS_LOCAL = import.meta.env.VITE_NAMESPACE === "local";
const IS_STAGING = import.meta.env.VITE_NAMESPACE === "staging";
export const IS_PRODUCTION = import.meta.env.VITE_NAMESPACE === "production";

export const APP_ROOT_DOMAIN = `${window.location.protocol}//${window.location.host}`;

export const LINEAR_PRIORITIES = [
  { value: 0, name: "No Priority" },
  { value: 1, name: "Urgent" },
  { value: 2, name: "High" },
  { value: 3, name: "Medium" },
  { value: 4, name: "Low" },
];

export const JIRA_PRIORITIES = [
  { value: 1, name: "Highest" },
  { value: 2, name: "High" },
  { value: 3, name: "Medium" },
  { value: 4, name: "Low" },
  { value: 5, name: "Lowest" },
];

const GITHUB_REDIRECT_URI = `${APP_ROOT_DOMAIN}/settings/integrations/github`;
const JIRA_REDIRECT_URI = `${APP_ROOT_DOMAIN}/settings/integrations/jira`;
const LINEAR_REDIRECT_URI = `${APP_ROOT_DOMAIN}/settings/integrations/linear`;
// const SLACK_REDIRECT_URI = `${APP_ROOT_DOMAIN}/settings/integrations/slack`;
const SLACK_REDIRECT_URI = IS_LOCAL
  ? "https://learning-shark-easily.ngrok-free.app/settings/integrations/slack"
  : `${APP_ROOT_DOMAIN}/settings/integrations/slack`; // temporary
// Fix in https://api.slack.com/apps/A08E2TZ39U4/oauth?
const ZENDESK_REDIRECT_URI = `${APP_ROOT_DOMAIN}/settings/integrations/zendesk`;

// sailfish-ai-test - dev
// sailfish-ai - prod
const githubAppName = import.meta.env.GITHUB_APP_NAME;

const JIRA_STATE = "tLt4jwm5rarjIbg4TVykDceQrE1sfuu2";
const JIRA_SCOPE_LIST = [
  "offline_access",
  "read:jira-work",
  "read:jira-user",
  "write:jira-work",
  "manage:jira-project",
  "manage:jira-webhook",
  "manage:jira-data-provider",
  "manage:jira-configuration",
  "read:workflow:jira",
];
const JIRA_SCOPE = encodeURIComponent(JIRA_SCOPE_LIST.join(" "));

export const INTEGRATIONS = {
  // GitHub
  GITHUB: "GitHub",
  GITHUB_APP_INSTALLATION_URL: `https://github.com/apps/${githubAppName}/installations/new`,
  GITHUB_REDIRECT_URI,
  GITHUB_INTEGRATIONS_PATH: "/settings/integrations#github",
  // Jira
  JIRA: "Jira",
  JIRA_REDIRECT_URI,
  JIRA_INTEGRATIONS_PATH: "/settings/integrations#jira",
  JIRA_OAUTH_URI: `https://auth.atlassian.com/authorize?audience=api.atlassian.com&scope=${JIRA_SCOPE}&redirect_uri=${JIRA_REDIRECT_URI}&state=${JIRA_STATE}&response_type=code&prompt=consent`,

  // Linear
  LINEAR: "Linear",
  LINEAR_REDIRECT_URI,
  LINEAR_INTEGRATIONS_PATH: "/settings/integrations#linear",
  LINEAR_OAUTH_URI: `https://linear.app/oauth/authorize?response_type=code&redirect_uri=${LINEAR_REDIRECT_URI}&state=tLt4jwm5rarjIbg4TVykDceQrE1sfuu2&scope=read,write,admin&actor=application`,
  // Slack
  SLACK: "Slack",
  SLACK_INSTALLATION_URL: `https://slack.com/oauth/v2/authorize?redirect_uri=https://learning-shark-easily.ngrok-free.app/settings/integrations/slack&client_id=6677841472737.8478951111956&scope=chat:write,channels:read,channels:manage,groups:read,groups:write,chat:write.public,im:write,users:read.email,users:read&user_scope=`,
  // SLACK_INSTALLATION_URL:
  //   "https://slack.com/oauth/v2/authorize?scope=chat%3Awrite%2Cchannels%3Aread%2Cchat%3Awrite.public%2Cim%3Awrite%2Cusers%3Aread.email%2Cusers%3Aread&amp;user_scope=&amp;redirect_uri=https%3A%2F%2Flearning-shark-easily.ngrok-free.app%2Fsettings%2Fintegrations%2Fslack&amp;client_id=6677841472737.8478951111956",
  SLACK_REDIRECT_URI,
  SLACK_INTEGRATIONS_PATH: "/settings/integrations#slack",
  // Zendesk
  ZENDESK: "Zendesk",
  ZENDESK_REDIRECT_URI,
  ZENDESK_INTEGRATIONS_PATH: "/settings/integrations#zendesk",
  getZendeskOauthUri: (subdomain: string) =>
    `https://${subdomain}.zendesk.com/oauth/authorizations/new` +
    `?response_type=code` +
    `&client_id=sailfishai` +
    `&redirect_uri=${encodeURIComponent(ZENDESK_REDIRECT_URI)}` +
    `&scope=read%20write%20tickets%3Aread%20tickets%3Awrite%20triggers%3Aread%20triggers%3Awrite%20webhooks%3Aread%20webhooks%3Awrite` +
    `&actor=application`,
};

export const JIRA_INTEGRATIONS_MESSAGE =
  "Note: This integration currently supports only a single Jira domain. If your domain changes, please contact Support to reconnect.";

export const SUPPORT_TICKET_INTEGRATIONS = [
  INTEGRATIONS.JIRA,
  INTEGRATIONS.LINEAR,
];

export const zendeskApiKey = import.meta.env.VITE_ZENDESK_API_KEY;

export const RECORDINGS_EMPTY_FILTERS = {
  pageVisitUrls: [],
  devices: [],
  user: null,
};

export const DEVICE_TYPES = {
  DESKTOP: "Desktop",
  MOBILE: "Mobile",
} as const;

export const DEMO_COMPANY_NAME = "Sailfish - DEMO";

export const INACTIVE_PERIOD_THRESHOLD_MS = 10000;

export const JWT_KEY = IS_STAGING ? "jwt-staging" : "jwt";
export const DOCS_DOMAIN = IS_STAGING
  ? "https://docs.staging.sailfishqa.com/"
  : "https://docs.sailfishqa.com/";

export const LOG_LEVELS = {
  Log: ["log", "info", "print", "UNKNOWN"],
  Warn: ["warn"],
  Error: ["error", "exception"],
};

export const WEB_PLAYER_TOAST_CONTAINER_ID = "webPlayerToastContainerId";

export const RELATIVE_OPTIONS = [
  { id: "today", name: "Today" },
  { id: "7days", name: "In past 7 days" },
  { id: "30days", name: "In past 30 days" },
] as const;
